import { memo } from 'react';

import type { CheckboxesActionField, BaseTypeProps } from 'schemaBuilder/types';

import { TypeWrapper } from '../../ui';

import CheckboxesBody from './body';

export interface Props extends BaseTypeProps {
  field: CheckboxesActionField;
}

export const Checkboxes = ({
  isDragging,
  field,
  dragElement,
  removeElement,
  typeSelectElement,
  fieldKeyElement,
  path,
  theme,
  readonly
}: Props) => {
  return (
    <TypeWrapper
      schemaField={field.schemaField}
      required={field.required}
      isDragging={isDragging}
      dragElement={dragElement}
      typeSelectElement={typeSelectElement}
      removeElement={removeElement}
      fieldKeyElement={fieldKeyElement}
      path={path}
      theme={theme}
      readonly={readonly}
    >
      <CheckboxesBody
        readonly={readonly}
        schemaField={field.schemaField}
        path={path}
      />
    </TypeWrapper>
  );
};

export default memo(Checkboxes);
